<mat-form-field class="w-100">
  @if (helpText) {
    <app-help-text [dataContext]="helpText"></app-help-text>
  }
  <input
    matInput
    type="time"
    [formControl]="control"
    [placeholder]="control.caption | translate"
    [required]="control.required ? true : null"
    [readonly]="control.isReadonly ? true : null"
    [ngClass]="{ locked: control.isReadonly }"
    (blur)="onblur()"
    (focus)="onfocus()"
    />
    @if (errorMessage) {
      <mat-error>{{ errorMessage.message | translate: errorMessage.params }}</mat-error>
    }
  </mat-form-field>
